import { Button } from "@do/ui/components/button";
import { cn } from "@do/ui/lib/utils";
import { HistoryIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useChat } from "../../../providers/chat-provider";
import { HeaderSettingsSection } from "./section";

export const HeaderSettingsRefresh = () => {
  const { onRefreshConversation } = useChat();
  const t = useTranslations("do-chat-v2");

  return (
    <HeaderSettingsSection
      id="refresh"
      title={t("chat.header.settings.refresh-chatbot.title")}
      description={t("chat.header.settings.refresh-chatbot.description")}
      icon={HistoryIcon}
    >
      <Button
        id="header-settings-dialog-content-section-button-refresh"
        variant="none"
        className={cn(
          "bg-(--header-settings-dialog-content-section-refresh-button-background)/(--header-settings-dialog-content-section-refresh-button-background-opacity)",
          "hover:bg-(--header-settings-dialog-content-section-refresh-button-hover-background)/(--header-settings-dialog-content-section-refresh-button-hover-background-opacity)",
          "text-(--header-settings-dialog-content-section-refresh-button-foreground)/(--header-settings-dialog-content-section-refresh-button-foreground-opacity)",
          "hover:text-(--header-settings-dialog-content-section-refresh-button-hover-foreground)/(--header-settings-dialog-content-section-refresh-button-hover-foreground-opacity)",
          "border-(length:--header-settings-dialog-content-section-refresh-button-border-width)",
          "border-(--header-settings-dialog-content-section-refresh-button-border-color)/(--header-settings-dialog-content-section-refresh-button-border-opacity)",
          "hover:border-(--header-settings-dialog-content-section-refresh-button-hover-border-color)/(--header-settings-dialog-content-section-refresh-button-hover-border-opacity)",
          "rounded-(--header-settings-dialog-content-section-refresh-button-border-radius)",
          "h-(--header-settings-dialog-content-section-refresh-button-height)",
          "font-(--header-settings-dialog-content-section-refresh-button-font-weight)!",
          "text-(length:--header-settings-dialog-content-section-refresh-button-font-size)",
          "font-(family-name:--header-settings-dialog-content-section-refresh-button-font-family)",
          "[box-shadow:var(--header-settings-dialog-content-section-refresh-button-box-shadow)]"
        )}
        onClick={onRefreshConversation}
      >
        {t("chat.header.settings.refresh-chatbot.button")}
      </Button>
    </HeaderSettingsSection>
  );
};
